module.exports = __webpack_public_path__ + "static/dynamicAir_logo-6bd7367abd65dc2f86811235d49e1bef.webp";